import * as turf from 'turf';

const reversePolygon = (coordinates) =>  {
    const reversedCoordinates = coordinates.map(([x, y]) => {
        return [y, x];
    });
    return reversedCoordinates;
}
const reversePolygons = (polygons) => polygons.map(p => reversePolygon(p));

/** Return polygons array from products array */
export const itemsToPolygons = (productList) => productList ? productList.filter((item) => item?.stac_item
    ? !!(item?.stac_item?.geometry?.coordinates)
    : !!item?.geometry?.coordinates).map((item) => {
  const coordinates = item?.stac_item
  ? item?.stac_item?.geometry?.coordinates
  : item?.geometry?.coordinates;

  if (!coordinates) return [];

  const reversedPolygons = item?.stac_item
    ? reversePolygons(coordinates)
    : reversePolygons(coordinates);
  const actualPolygon = turf.polygon(reversedPolygons);
  const actualPolygonCenter = turf.center(actualPolygon);

  return {
      id: item?.stac_item?.id || item.frame_id,
      center: actualPolygonCenter.geometry.coordinates,
      polygon: actualPolygon.geometry.coordinates,
      feature: actualPolygon.geometry,
      showPolygon: true
  };
}) : []
